
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["share-icon",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"38","viewBox":"0 0 52 52"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"26","cy":"26","fill":"#f37b8a","r":"26"}}),_c('path',{attrs:{"d":"M40.61 17.237a8.748 8.748 0 01-3.383.991 5.937 5.937 0 002.564-3.4 14 14 0 01-3.691 1.533 5.566 5.566 0 00-4.203-1.971 6.05 6.05 0 00-5.843 6.242c0 .44.1.991.1 1.423a16.18 16.18 0 01-12-6.461 6.3 6.3 0 00-.825 3.176 6.256 6.256 0 002.561 5.147 5.791 5.791 0 01-2.665-.771v.11a6.332 6.332 0 004.723 6.134 7.439 7.439 0 01-1.537.22 3.946 3.946 0 01-1.127-.11 5.685 5.685 0 005.433 4.271 11.213 11.213 0 01-7.174 2.628 6.345 6.345 0 01-1.433-.109 15.736 15.736 0 008.919 2.738c10.663 0 16.506-9.418 16.506-17.632v-.77a15.478 15.478 0 003.075-3.397zm0 0"}})])
          )
        }
      }
    